import { render, staticRenderFns } from "./studentControlPanel.vue?vue&type=template&id=76814f41&scoped=true"
import script from "./studentControlPanel.vue?vue&type=script&lang=js"
export * from "./studentControlPanel.vue?vue&type=script&lang=js"
import style0 from "./studentControlPanel.vue?vue&type=style&index=0&id=76814f41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76814f41",
  null
  
)

export default component.exports